// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ok-1";
export var messageSideRight = "_ok-2";
export var orderLookupBubbleContainer = "_ok-0";
export var submitButton = "_ok-3";